import { useAppSelector } from '@/Application/Hooks/Redux';

interface ShowTotalsCentAmount {
  cencoPayAmount: number;
  cencosudAmount: number;
  otherMethodsAmount: number;
}

export const useGetTotalsCentAmount = (): ShowTotalsCentAmount => {
  const { data: totals } = useAppSelector((state) => state.cartPayments);
  const { data: cart } = useAppSelector((state) => state.cart);

  const defaultPrice = cart?.totalPrice?.centAmount ?? 0;

  const otherMethod = totals?.otherMethod?.centAmount ?? 0;
  const otherMethodsAmount = otherMethod > 0 ? otherMethod : defaultPrice;

  const cencosud = totals?.cencosudCard?.centAmount ?? 0;
  const cencosudAmount = cencosud > 0 ? cencosud : defaultPrice;

  const cencoPay = totals?.cencoPay?.centAmount ?? 0;
  const cencoPayAmount = cencoPay > 0 ? cencoPay : defaultPrice;

  return { otherMethodsAmount, cencoPayAmount, cencosudAmount };
};

export default useGetTotalsCentAmount;
